<template>
  <div class="rating-container rating-container--outer m-10">
    <div v-if="!reviewSent">
      <p class="heading-3 mb-10">
        Ohodnoťte nás ({{ rating }}/5)
      </p>

      <stars v-model="rating"></stars>

      <div class="rating-container rating-container--inner">
        <text-field
          class="mt-10"
          title="Napíšte nám, čo sa vám páčilo alebo čo by ste zlepšili. Ďakujeme."
          :value="review"
          @input="setReview"
          :required="true"
          :is-text-area="true"
          :max-length=400
        ></text-field>
      </div>

      <div class="rating-container rating-container--inner mt-5">
        <Button
          v-if="!reviewSent"
          class="rating-submit-button"
          @click="sendReview">
          Odoslať hodnotenie
        </Button>
      </div>
    </div>
    <div v-else>
      <p class="heading-3 mt-0">
        Vaše hodnotenie bolo odoslané. Ďakujeme.
      </p>
    </div>
  </div>
</template>

<script>
import Stars from '@/components/Rating/Stars.vue';
import TextField from '@/components/TextField/TextField.vue';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Rating',
  components: {
    Button,
    TextField,
    Stars,
  },
  props: ['model'],
  data() {
    return {
      rating: 0,
      review: '',
      reviewSent: false,
    };
  },
  computed: {
  },
  methods: {
    sendReview() {
      if (this.rating > 0 || this.review !== '') {
        const UAparser = new UAParser(); // eslint-disable-line
        const device = UAparser.getDevice();
        const OS = UAparser.getOS();
        const browser = UAparser.getBrowser();

        const request = new FormData();
        request.append('rating', this.rating);
        request.append('voiceText', this.review);
        request.append('voiceInsuranceType', 'uzp');
        request.append('voiceInsuranceTypeNew', 'UZP');
        request.append('insuranceNumber', this.model.saveResponse[0].cislo);
        request.append('phone', this.model.insurer.phone);
        request.append('email', this.model.insurer.email);
        request.append('device', device.type ? device.type : 'PC');
        request.append('os', OS.name);
        request.append('osVersion', OS.version);
        request.append('browser', browser.name);
        request.append('browserVersion', browser.version);
        request.append('useragent', navigator.userAgent);

        this.$axios(
          {
            method: 'post',
            url: '/app/contact/sendFormVoice.js',
            data: request,
            headers: { 'Content-Type': 'multipart/form-data' },
          },
        )
          .then(() => {
            this.reviewSent = true;
          });
      }
    },
    setReview(review) {
      this.review = review.replace(/[^\p{L}\p{N}\s.,]/gu, '');
    },
  },
};
</script>
